import styled, { css } from 'styled-components';

import Header from '@veneer/core/dist/scripts/header';
import { LARGE_SCREEN_WIDTH_REM } from '../../utils/constants';

const rtlSwitch = dir => (dir === 'rtl' ? 'left' : 'right');
const textDirection = dir => (dir === 'rtl' ? 'right' : 'left');

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: middle;
  margin: 0 1.5rem;
  @media screen and (min-width: ${LARGE_SCREEN_WIDTH_REM}) {
    margin: 0;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
`;

export const Title = styled.span`
  color: rgba(33, 33, 33, 1);
  font-size: 1rem;
  line-height: 1.25rem;

  @media screen and (min-width: ${LARGE_SCREEN_WIDTH_REM}) {
    font-size: 1.125rem;
  }
`;

export const Expand = styled.button`
  color: rgba(2, 122, 174, 1);
  font-size: 0.813rem;
  line-height: 1.063rem;
  appearance: none;
  border: none;
  background-color: transparent;
  padding: 0;
  text-decoration: none;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  ${({ theme: { dir } }) =>
    `&:nth-of-type(2) {
      margin-${/* sc-custom "left" */ textDirection(dir)}: 1rem;
    }`}
   &:focus{
    outline:none;
   }
  &:focus-visible{
    outline: 1px solid #d3d3d3;
  }
  &:active,
  &:hover {
    text-decoration: none !important;
  }
  display: inline-block;
  visibility: visible;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const HeaderStyle = css`
  >div: nth-of-type(2) {
    font-size: 1rem;
    line-height: 1.25rem;
    font-family: SF Pro Text, arial, sans-serif;
    color: rgba(78, 78, 78, 1);
  }
`;

export const StyledHeader = styled(Header)`
  && {
    padding: 0;
    >div: first-of-type {
      display: flex;
    }
  }
  ${({ $isMobile, theme: { dir } }) =>
    $isMobile
      ? `
    && {
      height: 2.563rem;
      ${HeaderStyle}
    }
    `
      : `
    && {
      height: 3rem;
      justify-content: flex-start;
      > div: first-of-type {
        margin-${/* sc-custom "left" */ rtlSwitch(dir)}: 0.75rem;
        margin-${/* sc-custom "right" */ textDirection(dir)}: 0.25rem;
      }
      ${HeaderStyle}
    }
    `}
`;

export const LinkButton = styled.button`
  display: inline-flex;
  background-color:transparent;
  border:none;
  align-items: center;
  transform: ${({ theme: { dir } }) => (dir === 'rtl' ? 'scaleX(-1)' : 'scaleX(1)')};
  :hover {
    cursor: pointer;
  }
  &:focus-visible{
    outline: 1px solid #d3d3d3
  }
  &:focus {
    outline: none;
  }
`;
